// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__7_GPi","errorLogs":"styles_errorLogs__2Gt15"};